import { ChangeDetectionStrategy, Component, EventEmitter, input, Output } from "@angular/core";

@Component({
    selector: "nav-item",
    templateUrl: "./nav-item.component.html",
    styleUrl: "./nav-item.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NavItemComponent {
  label = input<string>();
  hideChevronRight = input<boolean>(false);

  @Output() itemClick = new EventEmitter<void>();

  public handleClick(): void {
    this.itemClick.emit();
  }
}
